// ── Shared project tag registry (C1511) ──
//
// First SPA consumer of `GET /projects/:id/tags` — before this task every tag suggestion
// surface (task-detail.js's getAvailableTags(), board-filters.js, workspace-tasks.js) built
// its name list by scraping `tags` off already-loaded tasks, so a tag with no task yet was
// invisible and no description was ever available. Same memoize-per-id discipline as
// lib/project.js / lib/statuses.js: cache the *promise* so concurrent callers share one
// in-flight request, fail open so a fetch hiccup degrades to "no suggestions" rather than
// breaking the host UI.

import { api } from '../api.js';

const _cache = new Map(); // projectId -> Promise<Tag[]>

// Fetches `GET /projects/:id/tags` — [{name, description, knowledge_file_id,
// knowledge_file_key}], already `ORDER BY name`. Fails open ([]) on error.
export async function loadTags(projectId) {
  if (!_cache.has(projectId)) {
    _cache.set(projectId, api.get(`/projects/${projectId}/tags`)
      .then(res => res.tags || [])
      .catch(() => []));
  }
  return _cache.get(projectId);
}

// Drop this project's cached list — call after any successful `POST /projects/:id/tags`
// (a new tag registered via the typeahead's create form) so the next loadTags() call
// re-fetches instead of serving the pre-create list.
export function invalidateTags(projectId) {
  _cache.delete(projectId);
}
